import { IServiceType } from '@aca-new/app/pages/main/shared/components/aside/shared/components/aside-menu/share/models/interfaces/service-type.interface';
import { EServiceTypeNumber } from '@aca-new/app/shared/models/enums/service-type-number.enum';
import { EServiceType } from '@aca-new/app/shared/models/enums/service-type.enum';
import { AppUserSettingService } from '@aca-new/app/shared/services/user-services/app-user-setting/app-user-setting.service';

/**
 * @param {EServiceType} serviceTypeId - Aside menu service type id.
 * @returns {string} Pending-orders API serviceType query code.
 */
export function toServiceTypeNumberValue(serviceTypeId: EServiceType): string {
  if (serviceTypeId === EServiceType.SP) {
    return EServiceTypeNumber.SC;
  }

  const enumKey = serviceTypeId as keyof typeof EServiceTypeNumber;

  return EServiceTypeNumber[enumKey] ?? '';
}

/**
 * @param {AppUserSettingService} appUserSettingService - User settings for visibility flags.
 * @returns {IServiceType[]} Product inspections service types for aside menu and hub filters.
 */
export function buildProductInspectionsAsideServiceTypes(appUserSettingService: AppUserSettingService): IServiceType[] {
  return [
    {
      id: EServiceType.PSI,
      abbreviation: 'PSI',
      label: 'APP_ASIDE.ASIDE_MENU.PRE_SHIPMENT_INSPECTION',
      path: '/book-inspection/psi/null',
    },
    {
      id: EServiceType.PEO,
      abbreviation: 'PEO',
      label: 'APP_ASIDE.ASIDE_MENU.PRE_CUSTOMER_CLEARANCE_INSPECTION',
      path: '/book-inspection/peo/null',
    },
    {
      id: EServiceType.CLC,
      abbreviation: 'CLC',
      label: 'APP_ASIDE.ASIDE_MENU.CONTAINER_LOADING_CHECK',
      path: '/book-inspection/clc/null',
    },
    {
      id: EServiceType.DUPRO,
      abbreviation: 'DUPRO',
      label: 'APP_ASIDE.ASIDE_MENU.DURING_PRODUCTION_INSPECTION',
      path: '/book-inspection/dupro/null',
      isVisible: !appUserSettingService.getIsQimaWQS(),
    },
    {
      id: EServiceType.SP,
      abbreviation: 'SC',
      label: 'APP_ASIDE.ASIDE_MENU.SAMPLE_COLLECTION',
      path: '/book-inspection/sp/null',
    },
    {
      id: EServiceType.PM,
      abbreviation: 'PM',
      label: 'APP_ASIDE.ASIDE_MENU.PRODUCTION_MONITORING',
      path: '/book-inspection/pm/null',
      isVisible: !appUserSettingService.getIsQimaWQS() || !appUserSettingService.getIsWqsEnabled(),
    },
    {
      id: EServiceType.IPC,
      abbreviation: 'IPC',
      label: 'APP_ASIDE.ASIDE_MENU.INITIAL_PRODUCTION_CHECK',
      path: '/book-inspection/ipc/null',
      isVisible: !appUserSettingService.getIsQimaWQS() || !appUserSettingService.getIsWqsEnabled(),
    },
    {
      id: EServiceType.SR,
      abbreviation: 'SR',
      label: 'APP_ASIDE.ASIDE_MENU.SAMPLE_REVIEW',
      path: '/book-inspection/sr/null',
    },
  ];
}
